import React, { Component } from 'react';
import Link from '../common/TrackedLink';

const dataLayer = global.dataLayer;
let eventAction;

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		};
	}

	handleClickProducts(e) {
		this.setState({
			subMenuLearn: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuProducts === false) {
			this.setState({ subMenuProducts: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuProducts: false });
			eventAction = 'collapse';
		}
		dataLayer.push({
			event: 'Footer',
			eventCategory: 'Footer',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickLearn(e) {
		this.setState({
			subMenuProducts: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuLearn === false) {
			this.setState({ subMenuLearn: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuLearn: false });
			eventAction = 'collapse';
		}
		dataLayer.push({
			event: 'Footer',
			eventCategory: 'Footer',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickSupport(e) {
		this.setState({
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuSupport === false) {
			this.setState({ subMenuSupport: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuSupport: false });
			eventAction = 'collapse';
		}
		dataLayer.push({
			event: 'Footer',
			eventCategory: 'Footer',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickOurBrands(e) {
		this.setState({
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuSupport: false
		});
		if (this.state.subMenuOurBrands === false) {
			this.setState({ subMenuOurBrands: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuOurBrands: false });
			eventAction = 'collapse';
		}
		dataLayer.push({
			event: 'Footer',
			eventCategory: 'Footer',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickPrivacySettings(e) {
		// console.log('handleClickPrivacySettings()');

		//IE9 & Other Browsers
		if (e.stopPropagation) {
			// console.log("Stopping propagation");
			e.stopPropagation();
		}

		if (dataLayer) {
			dataLayer.push({
				event: 'Footer',
				eventCategory: 'Footer',
				eventAction: 'Privacy Settings',
				eventLabel: e.currentTarget.textContent
			});
		}
		window.semaphore.push(['showPreferences'])
	}

	render() {
		return (
			<footer id="site-footer">
				<nav className="row links">
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuProducts ? 'active' : ''}`}
							onClick={e => this.handleClickProducts(e)}
						>
							Products
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuProducts ? 'active' : ''}`}>
								<li>
									<Link
										to="/products"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										All Products
									</Link>
								</li>
								<li>
									<Link
										to="/fire-waterproof-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Water and Fireproof Safes
									</Link>
								</li>
								<li>
									<Link
										to="/security-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Security Safes
									</Link>
								</li>
								<li>
									<Link
										to="/document-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Document Safes
									</Link>
								</li>
								<li>
									<Link
										to="/pistol-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Pistol Safes
									</Link>
								</li>
								<li>
									<Link
										to="/fire-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Fire Safes
									</Link>
								</li>
								<li>
									<Link
										to="/cash-boxes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Cash Boxes
									</Link>
								</li>
								<li>
									<Link
										to="/business-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Business Safes
									</Link>
								</li>
								<li>
									<Link
										to="/portable-safes"
										trackEvent="Footer"
										trackEventAction="Products"
									>
										Portable Safes
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuLearn ? 'active' : ''}`}
							onClick={e => this.handleClickLearn(e)}
						>
							Learn
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuLearn ? 'active' : ''}`}>
								<li>
									<Link
										to="/learn/buying-guide"
										trackEvent="Footer"
										trackEventAction="Learn"
									>
										Buying Guide
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/insights"
										trackEvent="Footer"
										trackEventAction="Learn"
										target="_blank"
									>
										Security and Safety Insights
									</Link>
								</li>
								<li>
									<Link
										to="/learn/about-us"
										trackEvent="Footer"
										trackEventAction="Learn"
									>
										About SentrySafe
									</Link>
								</li>
								<li>
									<Link
										to="/learn/customer-stories"
										trackEvent="Footer"
										trackEventAction="Learn"
									>
										Customer Stories
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/testimonial#submit-your-story"
										trackEvent="Footer"
										trackEventAction="Learn"
										target="_blank"
									>
										Share Your Story
									</Link>
								</li>
								<li>
									<Link
										to="/where-to-buy"
										trackEvent="Footer"
										trackEventAction="Learn"
									>
										Where To Buy
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuSupport ? 'active' : ''}`}
							onClick={e => this.handleClickSupport(e)}
						>
							Support
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuSupport ? 'active' : ''}`}>
								<li>
									<Link
										to="/support"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										All Support
									</Link>
								</li>
								<li>
									<Link
										to="/support/find-your-model-or-serial-number"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Find Your Model or Serial Number
									</Link>
								</li>
								<li>
									<Link
										to="/support/faqs/how-do-i-change-the-batteries-on-my-safe"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Need Help with Your Digital Lock&#63;
									</Link>
								</li>
								<li>
									<Link
										to="/support/faqs"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										FAQs
									</Link>
								</li>
								<li>
									<Link
										to="/support/lost-key-combo"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Lost Key or Combo
									</Link>
								</li>
								<li>
									<Link
										to="/support/videos"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Videos
									</Link>
								</li>
								<li>
									<Link
										to="/support/product-manuals"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Product Manuals
									</Link>
								</li>
								<li>
									<Link
										to="/support/contact-us"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Contact Us
									</Link>
								</li>
								<li>
									<Link
										to="/support/check-serial-number"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										Check Your Electronic Fire Safe
									</Link>
								</li>
								<li>
									<Link
										to="https://eloquamarketing.masterlock.com/PreferenceCenter"
										target="_blank"
										trackEvent="Footer"
									>
										Update Your Email Preferences
									</Link>
								</li>
								<li>
									<Link
										to="https://store.sentrysafe.com/"
										target="_blank"
										trackEvent="Footer"
										trackEventAction="Support"
									>
										SentrySafe Store
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuOurBrands ? 'active' : ''}`}
							onClick={e => this.handleClickOurBrands(e)}
						>
							Our Brands
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuOurBrands ? 'active' : ''}`}>
								<li>
									<Link
										to="https://www.masterlock.com/"
										trackEvent="Footer"
										trackEventAction="Our Brands"
										target="_blank"
										rel="noopener"
									>
										Master Lock
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/americanlock"
										trackEvent="Footer"
										trackEventAction="Our Brands"
										target="_blank"
										rel="noopener"
									>
										American Lock
									</Link>
								</li>
								<li>
									<Link
										to="/"
										trackEvent="Footer"
										trackEventAction="Our Brands"
									>
										SentrySafe
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
				</nav>
				<nav className="row social" itemScope itemType="https://schema.org/Organization">
					<link itemProp="url" href="https://www.sentrysafe.com" />
					<ul>
						<li>
							<Link
								to="https://www.facebook.com/sentrysafe/"
								className="fa fa-facebook"
								target="_blank"
								trackEvent="Footer"
								trackEventAction="social icon"
								itemProp="sameAs"
								rel="me"
							>
								<span className="assistive-text">
									Visit SentrySafe on Facebook
								</span>
							</Link>
						</li>
						{/*<li>*/}
						{/*	<Link*/}
						{/*		to="https://twitter.com/sentrysafe"*/}
						{/*		className="fa fa-twitter"*/}
						{/*		target="_blank"*/}
						{/*		trackEvent="Footer"*/}
						{/*		trackEventAction="social icon"*/}
						{/*		itemProp="sameAs"*/}
						{/*		rel="me"*/}
						{/*	>*/}
						{/*		<span className="assistive-text">*/}
						{/*			Visit SentrySafe on Twitter*/}
						{/*		</span>*/}
						{/*	</Link>*/}
						{/*</li>*/}
						<li>
							<Link
								to="https://www.instagram.com/sentrysafe"
								className="fa fa-instagram"
								target="_blank"
								trackEvent="Footer"
								trackEventAction="social icon"
								itemProp="sameAs"
								rel="me"
							>
								<span className="assistive-text">
									Visit SentrySafe on Instagram
								</span>
							</Link>
						</li>
						<li>
							<Link
								to="https://www.youtube.com/user/SentryGroup"
								className="fa fa-youtube-play"
								target="_blank"
								trackEvent="Footer"
								trackEventAction="social icon"
								itemProp="sameAs"
								rel="me"
							>
								<span className="assistive-text">
									Visit SentrySafe on YouTube
								</span>
							</Link>
						</li>
					</ul>
				</nav>
				<nav className="row">
					<div className="col legal">
						<ul>
							<li>
								<Link
									to="https://www.masterlock.com/privacy-policy"
									target="_blank"
									trackEvent="Footer"
								>
									Privacy Policy
								</Link>
							</li>
							<li>
								<a href='#'
									onClick={e => this.handleClickPrivacySettings(e)}>
									Privacy Settings
								</a>
							</li>
							<li>
								<Link
									to="https://www.masterlock.com/legal-statement"
									target="_blank"
									trackEvent="Footer"
								>
									Legal Statement
								</Link>
							</li>
							<li>
								<Link
									to="/site-map"
									trackEvent="Footer"
								>
									Site Map
								</Link>
							</li>
							<li>
								<Link
									to="https://www.masterlock.com/about-our-ads"
									target="_blank"
									trackEvent="Footer"
								>
									About Our Ads
								</Link>
							</li>
							<li>
								<Link
									to="https://www.fbin.com/app/uploads/2023/05/FBIN-Supplier-Code-of-Conduct.pdf"
									target="_blank"
									trackEvent="Footer"
								>
									Supplier Code of Conduct
								</Link>
							</li>
						</ul>
						<div className="copyright">
							&copy; {new Date().getFullYear()} Sentry Group. All Rights Reserved.
						</div>
					</div>
				</nav>
			</footer>
		);
	};
}

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/components/Footer.js